import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { CRMBearerTokenData, ITokenData } from 'types';
import { normaliseToken } from 'store/modules/options/normaliseConfigFromCRM';

const baseURL = process.env.REACT_APP_API_URL;

// Intercept all requests and return the data from the response
axios.interceptors.response.use(<T>(response: AxiosResponse<T>): T => response.data);

// @TODO Replace this with actual endpoint when it is created
export const makeGetRequestDEPRECATED = <T>(url: string, data: AxiosRequestConfig = {}) => axios.get<T>(`${baseURL}${url}`, {
  method: 'GET',
  responseType: 'json',
  ...data,
});

export const makePostRequestDEPRECATED = <T>(url: string, data: any) => axios.post<T>(`${baseURL}${url}`, {
  ...data,
});

const apiUrl: string = process.env.REACT_APP_CRM_API_URL;

export const makeGetRequest = <T>(url: string, params: Record<string, string> = {}, bearerToken: string, apiUrlPrefix: string = apiUrl) => axios.get<T>(`${apiUrlPrefix}${url}`, {
  method: 'GET',
  headers: {
    Authorization: `Bearer ${bearerToken}`,
  },
  params: {
    ...params,
  },
});

export const makePostRequest = <T>(url: string, data: any, bearerToken: string) => axios.post<T>(`${apiUrl}${url}`,
  data,
  {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${bearerToken}`,
    },
    params: {
      'Content-type': 'application/json',
    },
  });


const tokenApiUrl = process.env.REACT_APP_TOKEN_API_URL;
// const tenant = process.env.REACT_APP_API_TENANT;
// const clientId = process.env.REACT_APP_API_CLIENT_ID;
// const clientSecret = process.env.REACT_APP_CLIENT_SECRET;
// const resource = process.env.REACT_APP_API_RESOURCE;

// @NOTE CORS issues with the endpoint so the server is requesting the bearer token for us
export const fetchBearerToken = async (): Promise<ITokenData> => {
  const responseData = await axios.post<CRMBearerTokenData, CRMBearerTokenData>(tokenApiUrl);

  const tokenData = normaliseToken(responseData);

  return tokenData;
};

// @NOTE Uncomment this once the CORS issues have been sorted and we no longer
// need the server to proxy our requests for us
// export const fetchBearerToken = async (): Promise<ITokenData> => {
//   const url = `${tokenApiUrl}/${tenant}/oauth2/token`;
//   // const data = `grant_type=client_credentials&client_id=${clientId}&client_secret=${clientSecret}&resource=${resource}&redirect_uri=${window.location.href}`;
//   const data = [
//     'grant_type=client_credentials',
//     `client_id=${clientId}`,
//     `client_secret=${clientSecret}`,
//     `resource=${resource}`,
//   ];
//   const config: AxiosRequestConfig = {
//     method: 'POST',
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   };

//   const responseData = await axios.post<CRMBearerTokenData, CRMBearerTokenData>(url, data.join('&'), config);

//   const tokenData = normaliseToken(responseData);

//   return tokenData;
// };
